/* Horizontal product scrollers — ported from the Happikiddo prototype
   (pages/home.html page-bottom script). Inits on any .rail inside .hk-scope
   markup; guarded against double-init so multiple sections can load this file.

   Two rail shapes share this file:
   - true scrollers (bestsellers, related products) whose track overflows
   - static grids (gifts band, guides band) that use the .rail wrapper purely
     for layout and never overflow
   Drag-to-scroll only engages on the first kind. The prototype attached it
   unconditionally, which meant a few pixels of hand drift while clicking a
   gift tile cancelled the click on a track that had nothing to scroll. */
(function () {
  var DRAG_THRESHOLD = 8;   /* px of travel before a press counts as a drag, not a click */
  var ARROW_DURATION = 420; /* ms */

  function initRail(rail) {
    if (rail.dataset.hkRailInit) return;
    rail.dataset.hkRailInit = '1';

    var track = rail.querySelector('.rail-track');
    if (!track) return;
    var prevBtn = rail.parentNode.querySelector('.rail-arrow[data-dir="-1"]');
    var nextBtn = rail.parentNode.querySelector('.rail-arrow[data-dir="1"]');

    function scrollable() {
      return track.scrollWidth - track.clientWidth > 1;
    }
    function maxScroll() {
      return track.scrollWidth - track.clientWidth;
    }
    function groupStep() {
      var card = track.querySelector('.pcard, .rail-endcap');
      var w = card ? card.getBoundingClientRect().width : 240;
      return Math.round((w + 20) * 3);
    }
    function updateArrows() {
      if (!prevBtn || !nextBtn) return;
      prevBtn.classList.toggle('is-disabled', track.scrollLeft <= 1);
      nextBtn.classList.toggle('is-disabled', track.scrollLeft >= maxScroll() - 1);
    }

    /* The arrows animate the track themselves rather than calling
       scrollBy({behavior:'smooth'}). Mandatory scroll snapping competes with the
       UA's smooth-scroll animation, and the outcome varies by browser; driving
       scrollLeft per frame with snapping suspended behaves the same everywhere. */
    var arrowRaf = null;
    function animateTo(target) {
      if (arrowRaf) cancelAnimationFrame(arrowRaf);
      target = Math.max(0, Math.min(target, maxScroll()));
      var start = track.scrollLeft;
      var delta = target - start;
      if (Math.abs(delta) < 1) return;
      if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        track.scrollTo({ left: target, behavior: 'instant' });
        updateArrows();
        return;
      }
      var t0 = null;
      track.classList.add('is-animating');
      function step(ts) {
        if (t0 === null) t0 = ts;
        var p = Math.min(1, (ts - t0) / ARROW_DURATION);
        var eased = 1 - Math.pow(1 - p, 3);
        track.scrollTo({ left: start + delta * eased, behavior: 'instant' });
        if (p < 1) {
          arrowRaf = requestAnimationFrame(step);
        } else {
          arrowRaf = null;
          track.classList.remove('is-animating');
          updateArrows();
        }
      }
      arrowRaf = requestAnimationFrame(step);

      /* Frames stop being produced when the tab is backgrounded, which would
         otherwise leave the rail parked mid-animation with snapping suspended. */
      document.addEventListener('visibilitychange', function finish() {
        if (document.visibilityState !== 'hidden' || arrowRaf === null) return;
        cancelAnimationFrame(arrowRaf);
        arrowRaf = null;
        track.scrollTo({ left: target, behavior: 'instant' });
        track.classList.remove('is-animating');
        updateArrows();
        document.removeEventListener('visibilitychange', finish);
      });
    }

    if (prevBtn) prevBtn.addEventListener('click', function () { animateTo(track.scrollLeft - groupStep()); });
    if (nextBtn) nextBtn.addEventListener('click', function () { animateTo(track.scrollLeft + groupStep()); });

    /* Scroll indicator: a thin bar after the rail whose thumb mirrors the
       track's viewport. CSS decides where it shows (mobile only, where the
       arrows are hidden and nothing else says "this scrolls"). */
    var progress = document.createElement('div');
    progress.className = 'rail-progress';
    var thumb = document.createElement('span');
    thumb.className = 'rail-progress-thumb';
    progress.appendChild(thumb);
    rail.parentNode.insertBefore(progress, rail.nextSibling);

    function updateProgress() {
      if (!scrollable()) { progress.classList.remove('is-scrollable'); return; }
      progress.classList.add('is-scrollable');
      var frac = track.clientWidth / track.scrollWidth;
      var pos = track.scrollLeft / track.scrollWidth;
      thumb.style.width = (frac * 100) + '%';
      thumb.style.left = (pos * 100) + '%';
    }

    function updateAll() { updateArrows(); updateProgress(); }
    track.addEventListener('scroll', updateAll, { passive: true });
    window.addEventListener('resize', updateAll);
    /* Cards are lazy-loaded, so the scrollable width settles after first paint */
    window.addEventListener('load', updateAll);
    updateAll();

    /* Drag-to-scroll with momentum (mouse/pen; touch keeps native inertia) */
    var down = false, moved = false, startX = 0, startLeft = 0, lastX = 0, lastT = 0, v = 0, raf = null;
    /* Touch devices pan the track natively, with momentum the JS cannot match.
       Checked by media query as well as pointerType, because some Android
       browsers report a finger as "mouse" when a stylus or mouse is paired. */
    var coarsePointer = window.matchMedia && window.matchMedia('(hover: none), (pointer: coarse)');

    track.addEventListener('pointerdown', function (e) {
      if (e.pointerType === 'touch' || e.pointerType === 'pen') return;
      if (coarsePointer && coarsePointer.matches) return;
      if (!scrollable()) return;
      down = true; moved = false;
      startX = e.clientX; startLeft = track.scrollLeft;
      lastX = e.clientX; lastT = performance.now(); v = 0;
      if (raf) cancelAnimationFrame(raf);
      if (arrowRaf) { cancelAnimationFrame(arrowRaf); arrowRaf = null; track.classList.remove('is-animating'); }
      track.classList.add('is-pressing');
    });
    window.addEventListener('pointermove', function (e) {
      if (!down) return;
      var dx = e.clientX - startX;
      /* is-dragging puts pointer-events:none on the card links, so it must not
         go on until the press has actually become a drag. Setting it on
         pointerdown meant the press never hit-tested onto the link and the
         click that followed had no link to navigate to. */
      if (Math.abs(dx) > DRAG_THRESHOLD) {
        moved = true;
        track.classList.add('is-dragging');
      }
      if (!moved) return;
      track.scrollTo({ left: startLeft - dx, behavior: 'instant' });
      var now = performance.now(), dt = now - lastT;
      if (dt > 0) v = (e.clientX - lastX) / dt;
      lastX = e.clientX; lastT = now;
    });
    window.addEventListener('pointerup', function () {
      if (!down) return;
      down = false;
      track.classList.remove('is-dragging');
      track.classList.remove('is-pressing');
      var velocity = v * 16;
      function glide() {
        velocity *= 0.92;
        track.scrollTo({ left: track.scrollLeft - velocity, behavior: 'instant' });
        if (Math.abs(velocity) > 0.4) { raf = requestAnimationFrame(glide); }
        else { updateArrows(); }
      }
      if (Math.abs(velocity) > 0.5) glide();
      updateArrows();
    });
    track.addEventListener('click', function (e) {
      if (moved) { e.preventDefault(); e.stopPropagation(); moved = false; }
    }, true);
  }

  function initAll(root) {
    [].forEach.call((root || document).querySelectorAll('.rail'), initRail);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  /* Theme editor: re-init when a section is (re)loaded */
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
